// --------------------------------------------------------------
// Created On: 2025-04-01
// Author: Hannah Vaughan
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./SpeedChangeControls.module.scss";
import SpeedChangeButton from "./SpeedChangeButton/SpeedChangeButton";
import PanelSection from "../PanelSection/PanelSection";

// Container for all speed change button controls in the Speed Change section of the Remote Operation Panel.
export default function SpeedChangeControls(props: Props): Component {
  return (
    <PanelSection label="Speed Change">
      {props.defaultSpeeds.map((speed) => (
        <div className={`col-6 col-lg-3 px-3 ${styles.controlColumn}`} key={speed}>
          <SpeedChangeButton
            rpmValue={speed}
            showHertz={false}
            disabled={props.disabled}
            onClick={(rpm) => props.onChangeSpeed(rpm)}
          />
        </div>
      ))}
    </PanelSection>
  );
}

interface Props {
  disabled: boolean;
  defaultSpeeds: number[];
  onChangeSpeed: (rpm: number) => void;
}
